import { defineComponent } from 'vue';
import AccountService from '@/account/account.service';

export default defineComponent({
  inject: ['accountService'],
  data() {
    return {
      hasAnyAuthorityValues: {} as any,
    };
  },
  methods: {
    hasAnyAuthority(authorities: any): boolean {
      (this.accountService as () => AccountService)()
        .hasAnyAuthorityAndCheckAuth(authorities)
        .then(value => {
          if (this.hasAnyAuthorityValues[authorities] !== value) {
            this.hasAnyAuthorityValues = { ...this.hasAnyAuthorityValues, [authorities]: value };
          }
        });
      return this.hasAnyAuthorityValues[authorities] ?? false;
    },
    spaceLink(path: string): string {
      const spaceId = (this.$store.getters.space as any)?.id;
      return `/space/${spaceId ?? 'none'}/${path}`;
    },
  },
});
